import React from 'react';
import { ColorScale, MetricType } from './types';
import { formatMetricValue, getMetricDisplayName } from './utils';

interface MetricLegendProps {
  colorScale: ColorScale;
  metric: MetricType;
  className?: string;
}

const MetricLegend: React.FC<MetricLegendProps> = ({ colorScale, metric, className = '' }) => {
  const { min, max, colors } = colorScale;

  // Create legend steps
  const steps = colors.length;
  const legendItems = colors.map((color, index) => {
    const value = min + (index / (steps - 1)) * (max - min);
    return {
      color,
      value,
      label: formatMetricValue(value, metric),
    };
  });

  if (max === 0 || min === max) {
    return (
      <div className={`bg-white rounded-lg shadow-sm border border-gray-200 p-4 ${className}`}>
        <h3 className="text-sm font-medium text-gray-900 mb-2">
          {getMetricDisplayName(metric)}
        </h3>
        <p className="text-xs text-gray-500">
          No data available
        </p>
      </div>
    );
  }

  return (
    <div className={`bg-white rounded-lg shadow-sm border border-gray-200 p-2 ${className}`}>
      <h3 className="text-sm font-medium text-gray-900 mb-3">
        {getMetricDisplayName(metric)}
      </h3>

      {/* Color gradient bar */}
      <div className="mb-3">
        <div
          className="h-4 rounded-sm flex"
          style={{
            background: `linear-gradient(to right, ${colors.join(', ')})`,
          }}
        />
      </div>

      {/* Value labels */}
      <div className="flex justify-between text-xs text-gray-600">
        <span>
          {formatMetricValue(min, metric)}
        </span>
        <span>
          {formatMetricValue(max, metric)}
        </span>
      </div>

      {/* Discrete legend items (alternative view) */}
      {/* <div className="mt-3 space-y-1">
        {legendItems.slice(0, 3).map((item, index) => (
          <div
            key={index}
            className="flex items-center gap-2"
          >
            <div
              className="w-3 h-3 rounded-sm border border-gray-300"
              style={{ backgroundColor: item.color }}
            />
            <span className="text-xs text-gray-600">
              {index === 0 ? 'Low' : index === 1 ? 'Medium' : 'High'}
            </span>
          </div>
        ))}
      </div> */}
    </div>
  );
};

export default MetricLegend;
